import styled from '@emotion/styled';
import { css } from '@emotion/react';
const hideScrollBarPartialCSS = () => css `
  scrollbar-width: none; /* Firefox */
  scrollbar-height: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
  &::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    background: transparent; /* Chrome/Safari/Webkit */
  }
`;
const StyledScrollList = styled.ul `
  display: flex;
  height: inherit;
  overflow-x: scroll;
  overflow-y: hidden;
  position: relative;
  width: 100%;
  box-sizing: border-box;
  flex-shrink: 0;
  list-style-type: none;
  margin: 0;
  padding: 0;

  ${hideScrollBarPartialCSS}
`;
export default StyledScrollList;
